export class BasicUserInformation {
    public id: string;
    public userName: string | null = '';
    public fullName: string | null = '';

    constructor();
    constructor(userId: string, userName: string | null, fullName: string | null);
    constructor(userId?: string, userName?: string | null, fullName?: string | null) {
        if (userId !== undefined) {
            this.id = userId;
            this.userName = userName;
            this.fullName = fullName;
        }
    }
}